<span>
  <span *ngFor="let suffix of suffixes ; let first = first; let last = last">
    <span *ngIf="!first && !last">,</span>
    <span *ngIf="!first && last"> or </span>
    <strong>...{{suffix}}</strong>
  </span>.
</span>
